import * as React from 'react';

import TableCellBusy from './TableCellBusy';

interface Props extends React.ComponentPropsWithoutRef<'tr'> {
    loadingColumns?: number;
}

const TableRowBusy = ({ loadingColumns = 0, ...rest }: Props) => (
    <tr aria-busy="true" {...rest}>
        {[...Array(loadingColumns)].map((v, i) => (
            <TableCellBusy key={i.toString()} />
        ))}
    </tr>
);

export default TableRowBusy;
